import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * Get authorization code for an OAuth client
 */
export const authorizationCode = {
  name: "authorizationCode" as const,
  input: z.object({
    challenge: z.string().optional(),
    clientId: zExt.objectId(),
    redirectUri: z.string(),
  }),
  output: z.object({ code: z.string() }),
};
